import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Constants - Functions
import { pathHomePage } from "../../../../../../config/constants";
// Components
import {
  ProtocolReportDiv,
  ProtocolCardDiv,
  VideoButton,
  ProtocolImg,
  DiagnosisMarkDiv,
  DiagnosisMarkImg,
  VideoButtonImg,
  InfoImg,
  ReactTooltipStyled,
  ProtocolName,
  ShowPrescriptionsButton,
  ArrowImg,
  ExtraInfoDiv,
  ExtraInfoText,
  ReportsSectionDiv,
  SessionsDiv,
  ReportsLink,
  ReportsImg,
  SessionsNumber,
} from "./styles";
import ProtocolVideoPopup from "../../../../../protocolVideoPopup";
// Assets
import IcoArrowUp from "../../../../../../assets/icons/ico_arrow_up.svg";
import IcoArrowDown from "../../../../../../assets/icons/ico_arrow_down.svg";
import IcoOpenVideo from "../../../../../../assets/icons/ico_video.svg";
import IcoInfo from "../../../../../../assets/icons/ico_info_blue.svg";
import ReportsIco from "../../../../../../assets/icons/ico_reports.svg";
import DiagnosisIco from "../../../../../../assets/icons/ico_diagnostics.svg";

const RenderProtocol = ({ protocolId, sessionsNumber, protocolImg, protocolName, videoLink, protocolDescription }) => {
  const [isProtocolVideoShowed, setIsProtocolVideoShowed] = useState(false);
  const [isShowReports, setIsShowReports] = useState(false);
  const { clinicianToken, patientId, software } = useParams();
  const [t] = useTranslation("global");

  const handleShowPrescriptions = (e) => {
    e.preventDefault();
    setIsShowReports(!isShowReports);
  };

  const renderProtocolInfo = () => {
    const handleShowProtocolVideo = (e) => {
      e.preventDefault();
      setIsProtocolVideoShowed(true);
    };

    const renderToolTip = () => {
      return <ReactTooltipStyled id="protocolInfoDescription" place="top" type="dark" effect="solid" delayShow={100} delayHide={100} />;
    };

    return (
      <ProtocolCardDiv>
        <VideoButton onClick={handleShowProtocolVideo} disabled={!videoLink}>
          <ProtocolImg src={protocolImg} alt="protocol-img" />
          <DiagnosisMarkDiv>
            <DiagnosisMarkImg src={DiagnosisIco} alt="diagnosis-ico" />
          </DiagnosisMarkDiv>
          {videoLink ? (
            <VideoButtonImg src={IcoOpenVideo} alt="ico-video" data-for="protocolInfoDescription" data-tip={protocolDescription} />
          ) : (
            <InfoImg src={IcoInfo} alt="ico-info" data-for="protocolInfoDescription" data-tip={protocolDescription} />
          )}
          {renderToolTip()}
          <ProtocolName>{protocolName}</ProtocolName>
        </VideoButton>
        {isProtocolVideoShowed && <ProtocolVideoPopup setIsProtocolVideoShowed={setIsProtocolVideoShowed} protocolId={protocolId} />}
        <ShowPrescriptionsButton onClick={handleShowPrescriptions}>
          <ArrowImg src={isShowReports ? IcoArrowUp : IcoArrowDown} alt="ico-arrow" />
        </ShowPrescriptionsButton>
      </ProtocolCardDiv>
    );
  };

  const renderProtocolReports = () => {
    const getSessionsNumber = () => {
      if (!sessionsNumber) return "-";
      if (sessionsNumber > 99) return "+99";
      return sessionsNumber;
    };

    return (
      <ExtraInfoDiv show={isShowReports}>
        <ReportsSectionDiv>
          <ExtraInfoText>{t("reports").toUpperCase()}</ExtraInfoText>
          <SessionsDiv>
            <ReportsLink sessions={sessionsNumber} to={`${pathHomePage}/reports/${clinicianToken}/${software}/${patientId}/${protocolId}`}>
              <ReportsImg src={ReportsIco} alt="reports-btn" />
            </ReportsLink>
            <SessionsNumber>{getSessionsNumber()}</SessionsNumber>
          </SessionsDiv>
        </ReportsSectionDiv>
      </ExtraInfoDiv>
    );
  };

  return (
    <ProtocolReportDiv>
      {renderProtocolInfo()}
      {renderProtocolReports()}
    </ProtocolReportDiv>
  );
};

export default RenderProtocol;
